import { useQuery } from "@tanstack/react-query";
import { requestApi } from "@/shared/utills/http";
import { ITeamMemberSummary, ITeamMemberSkills } from "@/service/review-period";
import { ITeam, ITeamMemberValueDelivered } from "./model";

const ENDPOINTS = {
  MY_TEAMS: "/employee/my-teams",
  TEAM_MEMBER_SUMMARY: (teamId: number, fmno: string) => `/employee/my-teams/${teamId}/${fmno}/summary`,
  TEAM_MEMBER_SKILLS: (teamId: number, fmno: string) => `/employee/my-teams/${teamId}/${fmno}/skills`,
  TEAM_MEMBER_VALUE_DELIVERED: (teamId: number, fmno: string) => `/employee/my-teams/${teamId}/${fmno}/value`,
};

export const TEAM_ASSESSMENT_QUERY_KEYS = {
  MY_TEAMS: "my_teams",
  TEAM_MEMBER_SUMMARY: "teamMemberSummary",
  TEAM_MEMBER_SKILLS: "teamMemberSkills",
  TEAM_MEMBER_VALUE_DELIVERED: "teamMemberValueDelivered",
};

export const useGetTeamMemberSummary = (teamId?: number, fmno?: string) => {
  return useQuery({
    queryKey: [TEAM_ASSESSMENT_QUERY_KEYS.TEAM_MEMBER_SUMMARY, teamId, fmno],
    queryFn: async () => {
      const data = await requestApi<ITeamMemberSummary>({
        path: ENDPOINTS.TEAM_MEMBER_SUMMARY(teamId!, fmno!),
      });
      return data;
    },
    enabled: !!teamId && !!fmno,
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetTeamMemberSkills = (teamId?: number, fmno?: string) => {
  return useQuery({
    queryKey: [TEAM_ASSESSMENT_QUERY_KEYS.TEAM_MEMBER_SKILLS, teamId, fmno],
    queryFn: async () => {
      const data = await requestApi<ITeamMemberSkills>({
        path: ENDPOINTS.TEAM_MEMBER_SKILLS(teamId!, fmno!),
      });
      return data;
    },
    enabled: !!teamId && !!fmno,
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetTeamMemberValueDelivered = (teamId?: number, fmno?: string) => {
  return useQuery({
    queryKey: [TEAM_ASSESSMENT_QUERY_KEYS.TEAM_MEMBER_VALUE_DELIVERED, teamId, fmno],
    queryFn: async () => {
      const data = await requestApi<ITeamMemberValueDelivered>({
        path: ENDPOINTS.TEAM_MEMBER_VALUE_DELIVERED(teamId!, fmno!),
      });
      return data.value_delivered;
    },
    enabled: !!teamId && !!fmno,
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetMyTeams = () => {
  return useQuery({
    queryKey: [TEAM_ASSESSMENT_QUERY_KEYS.MY_TEAMS],
    queryFn: async () => {
      const data = await requestApi<ITeam[]>({
        path: ENDPOINTS.MY_TEAMS,
      });
      return data;
    },
  });
};
